export default __webpack_public_path__ + "static/media/p9.71327298.jpg";